<template>
  <div class="mo-root" :style="themePageStyle">
    <head>
      <meta charset="utf-8" /><title>FLOCKR | Make Offer</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link rel="shortcut icon" href="/assets/images/favicon.svg">
      <link href="/assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="/assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/custom.css" rel="stylesheet" type="text/css" />
    </head>
    <!-- was <body> — nested body breaks the DOM (document already has one) -->
    <div :data-sidebar="darkMode ? 'dark' : 'light'">
    <div id="layout-wrapper">
      <nav class="mo-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Make an Offer</span>
          </div>
          <button class="btn btn-sm btn-outline-secondary" @click="$router.back()">Cancel</button>
        </div>
      </nav>

      <div v-if="loading" class="text-center py-5" style="padding-top:100px!important;"><div class="spinner-border text-warning"></div></div>

      <div v-else class="container mo-container">
        <div class="row justify-content-center">
          <div class="col-lg-7">

            <div class="mo-card mb-3">
              <div class="d-flex align-items-center gap-3">
                <div class="mo-thumb">
                  <img v-if="listing.primary_photo || (listing.photos && listing.photos.length)" :src="photoUrl(listing.primary_photo || listing.photos[0].photo_url)" />
                  <i v-else class="mdi mdi-paw" style="font-size:24px;color:#BFA164;"></i>
                </div>
                <div>
                  <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">{{ listing.title }}</div>
                  <div style="color:#BFA164;font-weight:700;font-size:16px;">{{ (listing.currency || 'KES') }} {{ formatPrice(listing.price) }}</div>
                  <div style="color:var(--fm-s,#6B6356);font-size:12px;">{{ listing.species_name }} · {{ listing.county_name }} · {{ listing.price_type }}</div>
                </div>
              </div>
            </div>

            <div class="mo-card">
              <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);">Your Offer</h6>

              <div class="mb-3">
                <label class="mo-label">Offered Price (KES) <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text" style="background:var(--fm-bg3,#1E1E1E);border-color:#2A2520;color:#BFA164;font-weight:700;">KES</span>
                  <input v-model="form.offeredPrice" type="number" step="0.01" class="form-control mo-input" min="0" placeholder="0.00" />
                </div>
                <div v-if="form.offeredPrice && listing.price" class="mt-1" style="font-size:12px;" :style="priceDiffStyle">
                  {{ priceDiffText }}
                </div>
              </div>

              <div class="mb-3" v-if="listing.listing_type !== 'individual'">
                <label class="mo-label">Quantity</label>
                <input v-model="form.quantity" type="number" class="form-control mo-input" min="1" placeholder="1" />
              </div>

              <div class="mb-3">
                <label class="mo-label">Message to Seller</label>
                <textarea v-model="form.message" class="form-control mo-input" rows="3" placeholder="Introduce yourself, ask questions, or explain your offer..."></textarea>
              </div>

              <div v-if="submitError" class="alert alert-danger mb-3" style="background:#2D1111;border-color:#5C2020;color:#FF6B6B;font-size:13px;">
                <i class="mdi mdi-alert-circle me-1"></i> {{ submitError }}
              </div>

              <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary flex-fill" @click="$router.back()">Cancel</button>
                <button class="btn btn-warning flex-fill" @click="submitOffer" :disabled="!form.offeredPrice || submitting">
                  <span v-if="submitting"><span class="spinner-border spinner-border-sm me-1"></span> Sending...</span>
                  <span v-else><i class="mdi mdi-send me-1"></i> Submit Offer</span>
                </button>
              </div>
            </div>

            <div class="mo-tips mt-3">
              <div class="fw-semibold mb-2" style="color:#BFA164;font-size:13px;"><i class="mdi mdi-lightbulb-outline me-1"></i> Offer Tips</div>
              <ul style="color:var(--fm-m,#A09888);font-size:12px;margin:0;padding-left:16px;">
                <li>Offers expire after 72 hours if the seller doesn't respond</li>
                <li>The seller can accept, reject, or counter your offer</li>
                <li>Include a message to build trust and explain your interest</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<style>
html[data-theme="light"] body { background:#F7F5F2!important; color:#1A1A1A!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }

html[data-theme="light"] .mo-root,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .mo-container {
  background:#F7F5F2!important;
  color:#1A1A1A!important;
}

html[data-theme="light"] .mo-topbar {
  background:#FFFFFF!important;
  border-bottom-color:#E8E2DA!important;
}

html[data-theme="dark"] .mo-root,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .mo-container {
  background:#0A0A0A!important;
  color:#F5F0E8!important;
}

html[data-theme="dark"] .mo-topbar {
  background:rgba(10,10,10,.95)!important;
}
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
.mo-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh}
.mo-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.mo-container{padding-top:80px;padding-bottom:60px;background:transparent!important}
.mo-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:20px}
.mo-thumb{width:60px;height:60px;border-radius:8px;overflow:hidden;background:var(--fm-bg2,#0F0F0F)!important;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.mo-thumb img{width:100%;height:100%;object-fit:cover}
.mo-label{font-size:13px;font-weight:600;color:#D4C9B8!important;margin-bottom:6px;display:block}
.mo-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8)!important;border-radius:8px}
.mo-input:focus{border-color:#BFA164;background:var(--fm-bg2,#0F0F0F)!important;color:var(--fm-h,#F5F0E8)!important;box-shadow:0 0 0 2px rgba(191,161,100,.15)}
.mo-input::placeholder{color:#4A4540!important}
.mo-tips{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .mo-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .mo-card { padding: 14px !important; border-radius: 10px !important; }
  .mo-input { font-size: 16px !important; padding: 10px 12px !important; }
  .mo-thumb { width: 72px; height: 72px; }
  .mo-label { font-size: 12px !important; }
  .mo-tips { padding: 12px !important; }
}
</style>
<script>
import { executeJson, flocker, uploads } from "@/api";
export default {
  name: "MakeOfferPage",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true,submitting:false,submitError:'',listing:{},form:{offeredPrice:'',quantity:'1',message:''}}},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    priceDiffText(){
      var diff=Number(this.form.offeredPrice)-Number(this.listing.price);
      var pct=((diff/Number(this.listing.price))*100).toFixed(1);
      if(diff===0)return'Same as listing price';
      return(diff>0?'+':'')+pct+'% '+(diff>0?'above':'below')+' asking price';
    },
    priceDiffStyle(){
      var diff=Number(this.form.offeredPrice)-Number(this.listing.price);
      return{color:diff>=0?'#50C878':'#f1b44c'}
    }
  },
  mounted(){
    this.syncTheme();
    this.themeObserver = new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    var u=sessionStorage.getItem('userId');if(!u){this.$router.push('/login');return}
    var id=this.$route.params.listingId;if(id)this.load(id)
  },
  beforeUnmount(){
    if(this.themeObserver){this.themeObserver.disconnect()}
  },
  methods:{
    syncTheme(){
      var t=document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark';
      window.__flockrSetTheme(t);
      this.darkMode=t!=='light';
      if(document.body){
        document.body.setAttribute('data-sidebar',this.darkMode?'dark':'light');
        document.body.style.background=this.darkMode?'#0A0A0A':'#F7F5F2';
        document.body.style.color=this.darkMode?'#F5F0E8':'#1A1A1A';
      }
    },
    photoUrl(p){if(!p)return'';if(p.startsWith&&p.startsWith('http'))return p;return uploads+String(p).replace('uploads/','')},

    async load(id){
      this.loading=true;
      try{var r=await executeJson({function:"getListing",listingId:id,viewerId:sessionStorage.getItem('userId')||''},flocker);if(r.data.success)this.listing=r.data.data.listing||{}}catch(e){console.error(e)}
      this.loading=false
    },
    async submitOffer(){
      this.submitting=true;this.submitError='';
      try{
        var r=await executeJson({function:"makeOffer",listingId:this.listing.id,buyerId:sessionStorage.getItem('userId'),sellerId:this.listing.seller_id,offeredPrice:this.form.offeredPrice,quantity:this.form.quantity||'1',message:this.form.message},flocker);
        if(r.data.success){
          // Land the buyer on their offer thread so they can SEE what they just sent
          var oid = r.data.data && r.data.data.offerId;
          this.$router.push(oid ? ('/my-offers?offer='+oid) : '/my-offers');
        }
        else{this.submitError=r.data.message||'Failed to submit offer.'}
      }catch(e){this.submitError='Something went wrong.'}
      this.submitting=false
    },
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'}
  }
};
</script>
